import React from 'react';
import PropType from 'prop-types';
import PdfGenerationsByIndicationChart from './PdfGenerationsByIndicationChart';
import { IndicationsBreakDownBy } from '../../../util/constants';

PdfGenerationsByIndicationPdfActionChart.propTypes = {
	filterState: PropType.object,
	colorRegistry: PropType.object,
};

function PdfGenerationsByIndicationPdfActionChart(props) {
	return <PdfGenerationsByIndicationChart {...props} breakDownBy={IndicationsBreakDownBy.PdfActions} configKey='PdfGenerationsByIndicationPdfAction' />;
}

export default PdfGenerationsByIndicationPdfActionChart;
